import { $_app_server } from '@/_helpers'

export const reportDialogService = {
    getAll
}
let func = (response) => response.data

function getAll(reportUuid) {
  return $_app_server.get(`reportDialog/getAll/${reportUuid}`).then(func)
}